import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { UserService } from '../../services/user-service/user.service';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {
  constructor(
    private router: Router,
    private userService: UserService
  ) {}

  canActivate(): boolean {
    console.log("isAUth:",this.userService.getUserState().isAuthenticated);
    
    return !this.userService.getUserState().isAuthenticated;
  }
}